import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

import * as graph from '@shared/types/graphql'
import * as db from '@shared/types/database'
import A from '@/utilities/alpha'
import icoLookup from '@/utilities/ico-lookup'
import { formatDbPrototypes } from '@/utilities/asset-helpers'

@Component({
})
export default class ClientUpload extends Vue {
  @Prop({ required: true }) clientUploads!: graph.Prototype[]
  @Prop({ default: false }) showModal!: boolean
  @Prop({ default: false }) saveSubmitted!: boolean

  editableUploads: graph.Prototype[] = []
  errors: Record<string, string[]> = {}
  shownErrors: Record<string, string[]> = {}

  @Watch('clientUploads', { immediate: true, deep: true })
  updateUploads () {
    this.editableUploads = A.clone(this.clientUploads)
  }

  @Watch('saveSubmitted', { immediate: true })
  setVisibleErrors () {
    if (this.saveSubmitted) {
      this.saveUploads()
      this.$emit('resetErrorFlag')
    }
  }

  icoLookup () {
    return icoLookup
  }

  get areUploadsValid (): boolean {
    const errors = []
    for (const key in this.errors) {
      errors.push(...this.errors[key])
    }

    let newUpload = false
    this.editableUploads.forEach(upload => {
      // new upload was added, prevent from passing as valid until user tries to fill in both fields
      if (upload.url === '' || upload.title === '') newUpload = true
    })

    return ![...new Set(errors)].length && !newUpload
  }

  setErrors (errors: Record<string, string[]>) {
    this.errors = { ...errors, ...this.errors }
    this.$emit('fieldsValidated', { ...this.errors })
  }

  closeModal () {
    this.editableUploads = A.clone(this.clientUploads)
    this.clearErrors()
    this.$emit('hideUploadAssetModal')
  }

  editUpload (upload: graph.Prototype) {
    for (const i in this.editableUploads) {
      if (this.editableUploads[i].id === upload.id) {
        this.editableUploads[i] = upload
      }
    }

    this.$emit('areUploadsValid', this.areUploadsValid)
    this.$emit('editUpload', upload)
  }

  addUpload (upload: Record<string, db.Prototype>) {
    this.editableUploads.push(...formatDbPrototypes(upload))

    this.$emit('areUploadsValid', this.areUploadsValid)
    this.$emit('addUpload', upload)
  }

  removeUpload (id: string) {
    this.errors[id] = []
    for (let i = 0; i < this.editableUploads.length; i++) {
      if (this.editableUploads[i].id === id) {
        this.editableUploads.splice(i, 1)
      }
    }

    this.$emit('areUploadsValid', this.areUploadsValid)
    this.$emit('removeUpload', id)
  }

  saveUploads () {
    if (this.areUploadsValid) {
      this.clearErrors()
      this.$emit('saveUploads', this.editableUploads)
    } else {
      this.shownErrors = A.clone(this.errors)
      this.$emit('setErrors', this.errors)
    }
  }

  clearErrors () {
    this.errors = {}
    this.shownErrors = {}
  }
}
